import ISpeedingDataReport from "@/models/reports/speeding-data.report";
import ReportFeature from "./report.feature";

export default class SpeedingFeature extends ReportFeature {

    constructor(speed: ISpeedingDataReport) {
        super(speed, 'pointer_speeding', speed.index?.toString() || '', 'speeding')
    }

}